export default {
    completionOverView: {
        title: 'Complétion des questionnaires',
        totalSurveysTitle: 'Total de questionnaires',
        completedSurveysTitle: 'Questionnaires complets',
        notCompletedSurveysTitle: 'Questionnaires incomplets',
        notStartedSurveysTitle: 'Questionnaires non commencés'
    },
    respondantProfiles: {
        title: 'Profil des répondants'
    }
};